<template>
  <AdminLK v-if="isManager && !getFakeUser"/>
  <ApplicantsMns v-else-if="(isManager && getFakeUser) || !isExpert && !isTest"/>
</template>

<script>
import {mapGetters} from "vuex";
import ApplicantsMns from "@/2024/components/applicants/ApplicantsMns";
import AdminLK from "@/2024/components/applicants/admin/mns/AdminLK";

export default {
  name: "ApplicantsMnsView",
  components: {AdminLK, ApplicantsMns},
  computed: {
    ...mapGetters('keycloak', {
      getFakeUser: 'getFakeUser',
      isManager: 'isManager',
      isExpert: 'isExpert',
      isTest: "isTest"
    }),
  },
  created() {
    if (this.isExpert && !this.isManager) {
      this.$router.push({name: 'ApplicantsSelectionMns2024'});
    }
  }
}
</script>

<style scoped>

</style>